import { ApiClient } from "./ApiClient";
import { DistributionListAttributes } from "typings";
import qs from "qs";

const distributionListsPath = "/api/v2/distribution_lists";

const getById = (
  distributionListId: string,
  options: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().get(
    `${distributionListsPath}/${distributionListId}?${params}`,
  );
};

const getAll = ({
  sort,
  offset,
  limit,
  filter,
  include,
  number,
  size,
}: {
  sort?: string;
  offset?: number;
  limit?: number;
  number?: number;
  size?: number;
  include?: string[];
  filter?: {
    [key: string]: string | { [key: string]: string | undefined } | undefined;
  };
} = {}) => {
  const params = qs.stringify(
    {
      sort,
      include,
      page: {
        offset,
        limit,
        number,
        size,
      },
      filter,
    },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${distributionListsPath}?${params}`);
};

const getUsers = (
  distributionListId: string,
  options: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().get(
    `${distributionListsPath}/${distributionListId}/users?${params}`,
  );
};

const edit = (
  distributionListId: string,
  attributes: DistributionListAttributes,
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().patch(
    `${distributionListsPath}/${distributionListId}?${params}`,
    {
      data: {
        type: "distributionLists",
        id: distributionListId,
        attributes,
      },
    },
  );
};

const getReport = ({
  sort,
  offset,
  limit,
  filter,
  size,
  number,
  include,
}: {
  sort?: string;
  offset?: number;
  limit?: number;
  size?: number;
  number?: number;
  filter?: { [key: string]: string | undefined };
  include?: string[];
} = {}) => {
  const params = qs.stringify(
    {
      sort,
      include,
      page: {
        offset,
        limit,
        size,
        number,
      },
      filter,
    },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${distributionListsPath}/report?${params}}`);
};

export default { getById, getAll, getUsers, edit, getReport };
